import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';

/**
 * Everything below the first viewport is code-split so the Hero (LCP) ships
 * with the smallest possible JS payload. Each block reserves vertical space
 * while its chunk loads, which keeps CLS at zero.
 */
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const PositioningSection = lazy(() => import('./components/PositioningSection').then(m => ({
  default: m.PositioningSection
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FaqSection = lazy(() => import('./components/FaqSection').then(m => ({
  default: m.FaqSection
})));
const FinalCta = lazy(() => import('./components/FinalCta').then(m => ({
  default: m.FinalCta
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyBuyBar = lazy(() => import('./components/StickyBuyBar').then(m => ({
  default: m.StickyBuyBar
})));
interface DeferredProps {
  children: React.ReactNode;
  minHeight: string;
  background?: string;
}
function Deferred({
  children,
  minHeight,
  background = 'bg-ivory'
}: DeferredProps) {
  return <Suspense fallback={<div className={`w-full ${background}`} style={{
    minHeight
  }} aria-hidden data-id="element-1" data-mp="nvj4pj9gikrb" />} data-id="element-0" data-mp="3diruonbka37q">
      {children}
    </Suspense>;
}
export function App() {
  return <main className="w-full bg-ivory text-charcoal" data-id="element-2" data-mp="stccggqermtp">
      <Hero data-id="element-3" data-mp="3686tkdjumw2" />
      <Deferred minHeight="460px" data-id="element-4" data-mp="35ymodf6r9ya">
        <PainSection data-id="element-5" data-mp="34x2njg6zd4f" />
      </Deferred>
      <Deferred minHeight="560px" background="bg-sand" data-id="element-6" data-mp="3uct2xiigokzy">
        <PositioningSection data-id="element-7" data-mp="3uc9j1w993mja" />
      </Deferred>
      <Deferred minHeight="820px" data-id="element-8" data-mp="d4e6dvbvvgxr">
        <TomosSection data-id="element-9" data-mp="d3mil6oj2ni1" />
      </Deferred>
      <Deferred minHeight="520px" background="bg-sand" data-id="element-10" data-mp="d2l6cyvrzuyq">
        <BonosSection data-id="element-11" data-mp="86mgf6usu4w7" />
      </Deferred>
      <Deferred minHeight="440px" background="bg-sand" data-id="element-12" data-mp="83i6dsunkexm">
        <OfferSection data-id="element-13" data-mp="3gmfvdh9hf8b5" />
      </Deferred>
      <Deferred minHeight="380px" data-id="element-14" data-mp="3gja887keygi2">
        <TestimonialsSection data-id="element-15" data-mp="3bmthd5ltxo1a" />
      </Deferred>
      <Deferred minHeight="240px" background="bg-sand" data-id="element-16" data-mp="3bo4n3ayu55v1">
        <GuaranteeSection data-id="element-17" data-mp="3qbfwp7bgifsi" />
      </Deferred>
      <Deferred minHeight="420px" data-id="element-18" data-mp="3qciodhglsm9h">
        <FaqSection data-id="element-19" data-mp="3lkr6rwffdqvh" />
      </Deferred>
      <Deferred minHeight="380px" background="bg-sand" data-id="element-20" data-mp="3ljphamxnx1u8">
        <FinalCta data-id="element-21" data-mp="2xuwqt5zt7m70" />
      </Deferred>
      <Deferred minHeight="380px" background="bg-sand" data-id="element-22" data-mp="2xtv8cgggrxf9">
        <Footer data-id="element-23" data-mp="2svtm5mnqrhzk" />
      </Deferred>
      <Suspense fallback={null} data-id="element-24" data-mp="2swlgyv9ilbos">
        <StickyBuyBar data-id="element-25" data-mp="2svjxq3ichivz" />
      </Suspense>
    </main>;
}